import type { RequestConfig, RequestOptions } from "@@/plugin-request/request";
// import type { RequestConfig } from '@umijs/max';
import { getErrorMessage } from "@/type/errorCodes";
import { history } from "@umijs/max";
import { message } from "antd";

const loginPath = "/user/login";

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  code?: number;
  message?: string;
  timestamp?: number;
}

/**
 * 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */

export const AxiosConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { success, message, data, timestamp, code } =
        res as ResponseStructure;
      if (!success) {
        // @ts-ignore
        const error: any = new Error(message);
        error.name = "BizError";
        error.info = {
          success: success,
          data: data,
          code: code ?? -1,
          message: message ?? "未知错误",
          timestamp: timestamp ?? 0,
        };
        // 抛出自制的错误
        throw error;
      }
    },
    // 错误接收及处理
    errorHandler: async (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.name === "BizError") {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { message: msg, code } = errorInfo;
          message.error(msg);
          // switch (errorInfo.showType) {
          //   case ErrorShowType.SILENT:
          //     // do nothing
          //     break;
          //   case ErrorShowType.WARN_MESSAGE:
          //     message.warning(errorMessage);
          //     break;
          //   case ErrorShowType.ERROR_MESSAGE:
          //     message.error(errorMessage);
          //     break;
          //   case ErrorShowType.NOTIFICATION:
          //     notification.open({
          //       description: errorMessage,
          //       message: errorCode,
          //     });
          //     break;
          //   case ErrorShowType.REDIRECT:
          //     // TODO: redirect
          //     break;
          //   default:
          //     message.error(errorMessage);
          // }
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围

        const errorCode = error?.response?.data?.code;
        const errorMsg = error?.response?.data?.message;
        if (errorCode === "401") {
          message.error(getErrorMessage(401));
          history.push(loginPath);
        } else {
          if (errorMsg) {
            message.error(errorMsg);
          } else {
            message.error(getErrorMessage(errorCode || -1));
          }
        }
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        message.error("None response! Please retry.");
      } else {
        // 发送请求时出了点问题
        message.error("Request error, please retry.");
      }
    },
  },

  // // 请求拦截器
  // requestInterceptors: [
  //   (config: RequestOptions) => {
  //     // 拦截请求配置，进行个性化处理。
  //     const url = config?.url?.concat('?token=123');
  //     return { ...config, url };
  //   },
  // ],

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      const authHeader = {
        "x-access-token": `Bearer ${localStorage.getItem("userToken") || ""}`,
      };
      // 拦截请求配置，进行个性化处理。
      const url = config?.url;
      return { ...config, url, interceptors: true, headers: authHeader };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      // if (data?.success === false) {
      //   message.error("请求失败！");
      // }
      return response;
    },
  ],
};
